import { SentryConfig } from '../../infra';
import { getRuntimeEnv } from '../../infra';

const isProd = process.env.NODE_ENV === 'production';

function createSentryConfig(): SentryConfig | null {
    const runtimeEnv = getRuntimeEnv();

    // Skip Sentry initialization if DSN is not configured
    if (!runtimeEnv.sentryDsn) {
        return null;
    }

    const baseConfig: SentryConfig = {
        normalizeDepth: 6,
        dsn: runtimeEnv.sentryDsn,
    };

    if (isProd) {
        return {
            ...baseConfig,
            environment: 'production',
            enabled: true,
            debug: false,
            tracesSampleRate: 0.1,
        };
    }

    return {
        ...baseConfig,
        environment: 'development',
        enabled: false,
        debug: false,
        tracesSampleRate: 0.5,
    };
}

export const SENTRY_CONFIG = createSentryConfig();
